<template>
  <div class="block_center">
    <!-- Banner区域 -->
    <div class="banner" id="intro">
      <div class="bannerContent">
        <div style="height: 80px"></div>
        <div class="mainTitle">{{ $t("aboutUs.mainTitle") }}</div>
        <div class="subTitle">{{ $t("aboutUs.subTitle") }}</div>
        <div class="statsRow">
          <div style="display: flex; align-items: center">
            <div class="statDivider"></div>
            <div class="statItem">
              <div class="statNum">50<span class="plus">+</span></div>
              <div class="statLabel">{{ $t("aboutUs.ipRights") }}</div>
            </div>
          </div>
          <div style="display: flex; align-items: center">
            <div class="statDivider"></div>
            <div class="statItem">
              <div class="statNum">11<span class="plus">+</span></div>
              <div class="statLabel">{{ $t("aboutUs.inventionPatents") }}</div>
            </div>
          </div>
          <div style="display: flex; align-items: center">
            <div class="statDivider"></div>
            <div class="statItem">
              <div class="statNum">40%<span class="plus">+</span></div>
              <div class="statLabel">{{ $t("aboutUs.rdRatio") }}</div>
            </div>
          </div>
        </div>
        <div class="bannerDesc">
          <p>{{ $t("aboutUs.introParagraph1") }}</p>
          <p>{{ $t("aboutUs.introParagraph2") }}</p>
          <p>{{ $t("aboutUs.introParagraph3") }}</p>
        </div>
      </div>
    </div>

    <!-- 企业文化区域 -->
    <div class="cultureSection" id="culture">
      <div class="cultureCards">
        <div
          class="cultureCard"
          v-for="(item, index) in cultureList"
          :key="index"
          :style="{
            background: `url(${item.bg}) no-repeat center`,
            backgroundSize: '100% 100%',
          }"
        >
          <div class="cardTitle">{{ item.title }}</div>
          <div class="cardContent">
            <p v-for="(text, idx) in item.contents" :key="idx">{{ text }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 荣誉资质区域 -->
    <div class="honorsSection" id="qualifications">
      <div class="honorsDesc">
        <p>
          {{ $t("aboutUs.honorsDesc1")
          }}<span class="highlight">{{ $t("aboutUs.honorsHighlight1") }}</span
          >{{ $t("aboutUs.honorsDesc2") }}
        </p>
        <p>
          {{ $t("aboutUs.honorsDesc3")
          }}<span class="highlight">{{ $t("aboutUs.honorsHighlight2") }}</span>
        </p>
        <p>
          {{ $t("aboutUs.honorsDesc4")
          }}<span class="highlight">{{ $t("aboutUs.honorsHighlight3") }}</span
          >{{ $t("aboutUs.honorsDesc5") }}
        </p>
      </div>

      <div class="certificateCarousel">
        <el-carousel
          :interval="3000"
          type="card"
          height="400px"
          indicator-position="none"
          arrow="always"
        >
          <el-carousel-item
            v-for="(item, index) in certificateList"
            :key="index"
          >
            <div class="certificateCard">
              <div class="certificateImg">
                <el-image
                  :src="item.img"
                  :preview-src-list="[item.img]"
                  fit="contain"
                />
              </div>
              <div class="certificateName">{{ item.name }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 联系我们区域 -->
    <div class="contactUs" id="aboutmap">
      <div class="contactText">
        <div class="introTitle">
          <span class="blueTag">{{ $t("aboutUs.contactUs") }}</span>
        </div>
        <div class="introT">{{ $t("aboutUs.contactUsText") }}</div>
      </div>

      <div class="mapContainer">
        <iframe class="mapIframe" :src="srcIframe"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    language() {
      return this.$i18n.locale;
    },
    srcIframe() {
      return process.env.VUE_APP_RESOURCE_URL + "/static/aboutUs/address.html?lang=" + this.language + "&api=" + process.env.VUE_APP_BASE_API;
    },
    // 企业文化数据
    cultureList() {
      return [
        {
          title: this.$t("aboutUs.vision"),
          contents: [this.$t("aboutUs.visionText")],
          bg: require("../../assets/image/yuanjing.png"),
        },
        {
          title: this.$t("aboutUs.concept"),
          contents: [
            this.$t("aboutUs.conceptText1"),
            this.$t("aboutUs.conceptText2"),
          ],
          bg: require("../../assets/image/linian.png"),
        },
        {
          title: this.$t("aboutUs.mission"),
          contents: [
            this.$t("aboutUs.missionText1"),
            this.$t("aboutUs.missionText2"),
            this.$t("aboutUs.missionText3"),
          ],
          bg: require("../../assets/image/shiming.png"),
        },
        {
          title: this.$t("aboutUs.coreValues"),
          contents: [
            this.$t("aboutUs.coreValuesText1"),
            this.$t("aboutUs.coreValuesText2"),
          ],
          bg: require("../../assets/image/jiazhi.png"),
        },
      ];
    },

    // 证书列表
    certificateList() {
      return [
        // certificate_img1~17 暂时隐藏不展示，需要恢复时取消注释即可
        /* {
          img: require("../../assets/image/certificate_img1.jpg"),
          name: this.$t("aboutUs.certSpecialized"),
        },
        {
          img: require("../../assets/image/certificate_img2.jpg"),
          name: this.$t("aboutUs.certGazelle"),
        },
        {
          img: require("../../assets/image/certificate_img3.jpg"),
          name: this.$t("aboutUs.certGazelle"),
        },
        {
          img: require("../../assets/image/certificate_img4.jpg"),
          name: this.$t("aboutUs.certGazelle"),
        },
        {
          img: require("../../assets/image/certificate_img5.jpg"),
          name: this.$t("aboutUs.certGazelle"),
        },
        {
          img: require("../../assets/image/certificate_img6.jpg"),
          name: this.$t("aboutUs.certHighTech"),
        },
        {
          img: require("../../assets/image/certificate_img7.jpg"),
          name: this.$t("aboutUs.certSoftware"),
        },
        {
          img: require("../../assets/image/certificate_img8.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        {
          img: require("../../assets/image/certificate_img9.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        {
          img: require("../../assets/image/certificate_img10.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        {
          img: require("../../assets/image/certificate_img11.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        {
          img: require("../../assets/image/certificate_img12.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        {
          img: require("../../assets/image/certificate_img13.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        {
          img: require("../../assets/image/certificate_img14.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        {
          img: require("../../assets/image/certificate_img15.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        {
          img: require("../../assets/image/certificate_img16.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        {
          img: require("../../assets/image/certificate_img17.jpg"),
          name: this.$t("aboutUs.certPatent"),
        }, */
        {
          img: require("../../assets/image/certificate_img18.jpg"),
          name: this.$t("aboutUs.certSurveyingB"),
        },
        {
          img: require("../../assets/image/certificate_img19.jpg"),
          name: this.$t("aboutUs.certGazelleShort"),
        },
        {
          img: require("../../assets/image/certificate_img20.jpg"),
          name: this.$t("aboutUs.certQualitySystem"),
        },
        {
          img: require("../../assets/image/certificate_img21.jpg"),
          name: this.$t("aboutUs.certWuhanAi"),
        },
        {
          img: require("../../assets/image/certificate_img22.jpg"),
          name: this.$t("aboutUs.certGisEval"),
        },
        {
          img: require("../../assets/image/certificate_img23.jpg"),
          name: this.$t("aboutUs.certInnovativeProduct"),
        },
        {
          img: require("../../assets/image/certificate_img24.jpg"),
          name: this.$t("aboutUs.certHighTech"),
        },
        {
          img: require("../../assets/image/certificate_img25.jpg"),
          name: this.$t("aboutUs.certPatent"),
        },
        /*{
          img: require("../../assets/image/certificate_img26.jpg"),
          name: this.$t("aboutUs.certInnovationContest"),
        },*/
        {
          img: require("../../assets/image/certificate_img27.jpg"),
          name: this.$t("aboutUs.certSoftwareShort"),
        },
        {
          img: require("../../assets/image/certificate_img28.jpg"),
          name: this.$t("aboutUs.certHunanGrand"),
        },
        {
          img: require("../../assets/image/certificate_img29.jpg"),
          name: this.$t("aboutUs.certShandongAward"),
        },
        /*{
          img: require("../../assets/image/certificate_img30.jpg"),
          name: this.$t("aboutUs.certSoftwareAssoc"),
        },*/
        {
          img: require("../../assets/image/certificate_img31.jpg"),
          name: this.$t("aboutUs.certReal3dEval"),
        },
      ];
    },
  },
  mounted() {
    const anchor = this.$route.query.familyCode || this.$route.query.name;
    if (anchor) {
      this.$nextTick(() => {
        const el = document.querySelector("#" + anchor);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top, behavior: "smooth" });
        }
      });
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.block_center {
  margin-top: 80px;
}

/* Banner区域 */
.banner {
  background-image: url("../../assets/image/关于我们Banner1.png");
  background-size: cover;
  background-position: center;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .bannerContent {
    position: relative;
    z-index: 1;
    text-align: center;
    color: #fff;
    padding: 60px 20px;

    .mainTitle {
      font-size: 56px;
      font-weight: 700;
      letter-spacing: 8px;
      margin-bottom: 10px;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    }

    .subTitle {
      font-size: 20px;
      font-weight: 300;
      letter-spacing: 4px;
      color: rgba(255, 255, 255, 0.8);
      margin-bottom: 40px;
    }

    .statsRow {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 40px;
      margin-bottom: 40px;

      .statItem {
        text-align: center;

        .statNum {
          font-size: 48px;
          font-weight: 700;
          color: #fff;

          .plus {
            font-size: 32px;
            margin-left: 4px;
          }
        }

        .statLabel {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
        }
      }

      .statDivider {
        width: 12px;
        height: 90px;
        background: url("../../assets/image/dervier.png") no-repeat center;
        background-size: 100% 100%;
      }
    }

    .bannerDesc {
      max-width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;

      p {
        font-size: 16px;
        line-height: 2;
        color: rgba(255, 255, 255, 0.9);
        margin: 0;
        width: fit-content;
        max-width: none;
        text-align: center;
        white-space: nowrap;
      }
    }
  }
}

/* 企业文化区域 */
.cultureSection {
  padding: 80px 0;
  background: #f7f8fb;

  .cultureCards {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    gap: 15px;

    .cultureCard {
      flex: 1;
      background: #fff;
      border-radius: 8px;
      padding: 20px 18px 38px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
      transition: all 0.3s;
      background-size: 100% 100%;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      }

      .cardTitle {
        font-size: 24px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 15px;
      }

      .cardContent {
        p {
          font-size: 13px;
          color: #ccc;
          line-height: 1.5;
          margin: 0 0 8px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

/* 荣誉资质区域 */
.honorsSection {
  padding: 80px 0;
  background: #fff;

  .honorsDesc {
    text-align: center;
    margin-bottom: 60px;

    p {
      font-size: 16px;
      color: #666;
      line-height: 2;
      margin: 0;

      .highlight {
        color: #333;
        font-weight: 600;
      }
    }
  }

  .certificateCarousel {
    width: 1200px;
    margin: 0 auto;
    background: linear-gradient(180deg, #e8f0f9, #fff);
    padding: 20px 40px;
    border-radius: 8px;

    ::v-deep .el-carousel__item {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    ::v-deep .el-carousel__mask {
      background-color: transparent !important;
    }

    ::v-deep .el-carousel__arrow {
      width: 50px;
      height: 50px;
      font-size: 20px;
      background: rgba(0, 0, 0, 0.3);

      &:hover {
        background: rgba(0, 0, 0, 0.5);
      }
    }

    .certificateCard {
      text-align: center;
      width: 100%;

      .certificateImg {
        width: 280px;
        // 固定高度，竖图按 contain 等比缩放到完整可见，避免高度 100% 被名称区域挤出截断
        height: 320px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;

        ::v-deep .el-image {
          width: 100%;
          height: 100%;
        }

        ::v-deep .el-image__inner {
          object-fit: contain;
        }
      }

      .certificateName {
        margin-top: 16px;
        font-size: 14px;
        color: #666;
      }
    }
  }
}

/* 联系我们区域 */
.contactUs {
  background: rgba(247, 248, 251, 1);

  .contactText {
    padding: 100px 0;
  }

  .introTitle {
    font-size: 36px;
    font-weight: 900;
    letter-spacing: 0px;
    line-height: 56px;
    color: rgba(56, 56, 56, 1);
    text-align: center;
    vertical-align: top;
  }

  .introT {
    font-size: 30px;
    font-weight: 400;
    letter-spacing: 13px;
    line-height: 43.44px;
    color: rgba(56, 56, 56, 1);
    text-align: center;
    vertical-align: top;
  }

  .blueTag {
    position: relative;
    z-index: 10;
  }

  .blueTag::after {
    content: "";
    display: inline-block;
    background-color: rgba(43, 133, 229, 1);
    position: absolute;
    right: -20px;
    top: 16px;
    height: 10px;
    width: 83px;
    z-index: -1;
  }
}

.mapContainer {
  width: 1200px;
  height: 600px;
  margin: 0 auto;
  margin-bottom: 80px;

  .mapIframe {
    width: 100%;
    height: 100%;
    border: 0px;
    border-radius: 20px;
    overflow: hidden;
  }
}
</style>
